import BulkAddToWishlistFlow, { type BulkAddToWishlistFlowProps } from "./BulkAddToWishlistFlow";
import { useDispatch } from "react-redux";
import { addOrderDetailsToWishlist } from "../../../../Wishlist/redux/actions";
import { type OrderLineItemData } from "../../../common/modelsV2";

type SelfProps = Pick<BulkAddToWishlistFlowProps, "onClose"> & {
  selectedOrderItems: OrderLineItemData[];
};

export const OrderDetailsAddToWishlistFlow = ({ onClose, selectedOrderItems }: SelfProps) => {
  const dispatch = useDispatch();

  const handleAddToWishlist = (data: { wishlistId: string } | { wishlistName: string }) => {
    return dispatch(addOrderDetailsToWishlist(data, selectedOrderItems));
  };

  return <BulkAddToWishlistFlow onClose={onClose} onAddToWishlist={handleAddToWishlist} />;
};

export default OrderDetailsAddToWishlistFlow;
